// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__baCSF","modal":"Modal_modal__EqaZW","closeButton":"Modal_closeButton__ttgYD","modal-open":"Modal_modal-open__f4c9+"};